/**
 * The owners' ownership percentages (ADR-0028 / ADR-0046 amendment, 2026-10-22):
 * each is above 0, at most 100, with at most three decimals; together they may not
 * exceed 100 (they need not reach it), and owners holding 50% or less together
 * cannot approve anything. The wording matches what the server answers, so a
 * refusal here and a refusal there read the same.
 */

const RANGE_PROBLEM = 'Ownership must be a percentage above 0 and no more than 100.';
const DECIMALS_PROBLEM = 'Ownership can have at most three decimal places.';

/** Thousandths of a percent — the exact unit the server counts in. */
export function pctToMilli(pct: number): number {
  return Math.round(pct * 1000);
}

/** What a typed percentage means: the number, or the plain sentence saying why not. */
export function parseOwnershipPct(text: string): { pct: number | null; problem: string | null } {
  const trimmed = text.trim().replace(/%$/, '').trim();
  if (trimmed === '') return { pct: null, problem: 'Enter the ownership percentage.' };
  if (!/^\d*\.?\d*$/.test(trimmed) || trimmed === '.') {
    return { pct: null, problem: RANGE_PROBLEM };
  }
  const pct = Number(trimmed);
  if (!Number.isFinite(pct) || pct <= 0 || pct > 100) return { pct: null, problem: RANGE_PROBLEM };
  if (Math.abs(pct * 1000 - Math.round(pct * 1000)) > 1e-6) {
    return { pct: null, problem: DECIMALS_PROBLEM };
  }
  return { pct, problem: null };
}

export const OWNERSHIP_TOTAL_PROBLEM =
  'The owners’ ownership cannot add up to more than 100%. Lower a percentage first.';

export { ownershipLowWarning } from '@dataroom/shared';
